const SkillsData = [
  {
    id: "1",
    name: "Python",
    image: require("../assets/Images/python.png"),
  },
  {
    id: "2",
    name: "Excel",
    image: require("../assets/Images/excel.png"),
  },
  {
    id: "3",
    name: "SQL",
    image: require("../assets/Images/sql.png"),
  },
  {
    id: "4",
    name: "NumPy",
    image: require("../assets/Images/numpy.png"),
  },
  {
    id: "5",
    name: "Pandas",
    image: require("../assets/Images/pandas.png"),
  },
  {
    id: "6",
    name: "MatplotLib",
    image: require("../assets/Images/matplotlib.png"),
  },
  {
    id: "7",
    name: "PowerBI",
    image: require("../assets/Images/power-bi.png"),
  },
   {
    id: "8",
    name: "AI",
    image: require("../assets/Images/AI.png"),
  },
   {
    id: "9",
    name: "ML",
    image: require("../assets/Images/ML.png"),
  },
  {
    id: "10",
    name: "MySQL",
    image: require("../assets/Images/mysql.png"),
  },
  {
    id: "11",
    name: "VS Code",
    image: require("../assets/Images/vscode.png"),
  },
  {
    id: "12",
    name: "Git",
    image: require("../assets/Images/git.png"),
  },
  {
    id: "13",
    name: "GitHub",
    image: require("../assets/Images/github.png"),
  },
];

export default SkillsData;
